import styled from 'styled-components';
import Colors from 'constants/Colors';

const Test1Container = styled.div`
  position: relative;
  max-width: 800px;
  margin: 0 auto;
`;

export { Test1Container };

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 48px;
`;

export { ButtonContainer };
